import Vue from 'vue'

export const EventBus = new Vue()

export const EventBusType = {
    INFORM: 'INFORM',
    CLOSE_INFORM: 'CLOSE_INFORM',
    TOAST: 'TOAST',
    CREATE_PROJECT: 'CREATE_PROJECT',
    SELECT_PROJECT: 'SELECT_PROJECT',
    SELECT_PROJECT_DONE: 'SELECT_PROJECT_DONE',
    CONFIRM: 'CONFIRM',
    CONFIRM_DONE: 'CONFIRM_DONE',
    CREATE_API_KEY: 'CREATE_API_KEY',
    CREATE_API_KEY_DONE: 'CREATE_API_KEY_DONE'
}
